import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { selectedTenantSelector } from '@cbridge-packages/tenant';
import { searchFilterSelector } from '@cbridge-modules/search-filter';
import { UserListAction } from '../userList.action';

type IState =
  & IGetSelectorStateType<typeof selectedTenantSelector>
  & IGetSelectorStateType<typeof searchFilterSelector>;

export const reloadUserListEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOf(UserListAction.reload),
  withLatestFrom(state$),
  mergeMap(([, state]) => {
    const tenantId = selectedTenantSelector(state);
    const search = searchFilterSelector(state);

    return [
      UserListAction.load({ tenantId, search }),
    ];
  }),
);
